// assets
import { IconBuildingSkyscraper, IconPlus, IconUsers } from '@tabler/icons';

// constant
const icons = { IconBuildingSkyscraper, IconPlus, IconUsers };

// ==============================|| SPECIAL CONFIGS MENU ITEMS ||============================== //

const specialConfigs = {
  id: 'specialConfigs',
  title: 'Configurações especiais',
  type: 'group',
  children: [
    {
      id: 'specialcompanies-view',
      title: 'Organizações',
      type: 'collapse',
      icon: icons.IconBuildingSkyscraper,
      breadcrumbs: true,
      children: [
        {
          id: 'specialcompanies-view',
          title: 'Organizações',
          type: 'item',
          url: 'organizations',
          icon: icons.IconBuildingSkyscraper
        },
        {
          id: 'specialcompanies-create',
          title: 'Nova organização',
          type: 'item',
          url: 'organizations/add',
          icon: icons.IconPlus
        }
      ]
    },
    {
      id: 'specialprofiles-view',
      title: 'Perfis',
      type: 'item',
      url: 'profiles',
      icon: icons.IconUsers,
      breadcrumbs: true
    }
  ]
};

export default specialConfigs;
